export class ISplMessage {
    lineNumber: number;
    fieldName: string;
    message: string;
    messageType: string;
}
